import { Pagination, Select, Table } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const { Option } = Select;

export const TableCustomV3 = ({ isLoading,columns, dataSource, totalItem, params, setParams, ...props }) => {
  return (
    <Table
      {...props}
      loading={isLoading}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      scroll={{
        x: 'max-content',
      }}
      footer={() =>
        dataSource?.length > 0 ? (
          <div className="flex flex-row justify-between">
            <Pagination
              pageSize={params?.limit}
              current={params?.pageId}
              total={totalItem}
              onChange={(page) => setParams({ ...params, pageId: page })}
              showSizeChanger={false}
              itemRender={(current, type, originalElement) => {
                if (type === 'prev') {
                  return <CaretLeftOutlined />;
                }
                if (type === 'next') {
                  return <CaretRightOutlined />;
                }
                return originalElement;
              }}
            />
            <div className="flex flex-row justify-end items-center gap-2">
              <Select value={params?.limit} onChange={(value) => setParams({ ...params, pageId: 1, limit: value })}>
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={50}>50</Option>
              </Select>
              <div className="text-sm text-[#667085] whitespace-nowrap">
                Hiển thị từ {(params?.pageId - 1) * params?.limit + 1}-
                {Math.min(params?.pageId * params?.limit, totalItem)} của {totalItem}
              </div>
            </div>
          </div>
        ) : null
      }
      bordered
      // rowClassName={(record, index) =>
      //   index % 2 === 0 ? 'bg-gray-100 hover:bg-gray-200' : 'bg-white hover:bg-gray-200'
      // }
      // className="bg-white border rounded-lg"
    />
  );
};

TableCustomV3.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  columns: PropTypes.object.isRequired,
  dataSource: PropTypes.array.isRequired,
  totalItem: PropTypes.number.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
};
